import { Instance } from 'flatpickr/dist/types/instance';

const toggleClass = (el: HTMLElement, className: string, bool: boolean) => {
  bool ? el.classList.add(className) : el.classList.remove(className);
};

export const positionFlatpickrCalendar = (
  fp: Instance,
  relativeEl: HTMLElement | undefined,
  appendTo: HTMLElement | undefined,
) => {
  if (!fp.calendarContainer || !relativeEl || !appendTo) return;

  const PADDING = 6;
  const calendarEl = fp.calendarContainer;
  const relativeToBounds = relativeEl?.getBoundingClientRect();
  const parentBounds = appendTo.getBoundingClientRect();

  const top = window.scrollY + relativeToBounds.top + PADDING;
  calendarEl.style.top = `${top}px`;
  toggleClass(calendarEl, 'arrowTop', true);
  toggleClass(calendarEl, 'arrowBottom', false);

  const left = window.scrollX + relativeToBounds.left - parentBounds.left;
  calendarEl.style.left = `${left}px`;
};
